<template>
	<b-card class="sa-card sa-card-border" header="Attività e Terapie" header-tag="header" footer-tag="footer" title=""> </b-card>
</template>

<script>
import UtilityMixin from "../../../utility/UtilityMixin";
export default {
	mixins: [UtilityMixin],
	data() {
		return {
			idAccettazione: null,
			pathResource: "/rsaplanning",
			planningGiornalieroFilter: { dataRiferimento: new Date().getTime(), giornaliero: true },
			jaonData: [{ dataOra: 1749052800000 }, {}],
		};
	},
	mounted() {
		this.idAccettazione = this.$route.params.id;
		if (this.idAccettazione) {
			this.planningGiornalieroFilter.idAccettazione = this.idAccettazione;
		}
		this.loadData();
	},
	methods: {
		loadData() {
			let me = this;
			me.$emit("beforeLoadData");

			UtilityMixin.methods.loadDataResources(me.pathResource, me.planningGiornalieroFilter, me.loadDataSuccess, me.loadDataError);
		},
		loadDataSuccess(response) {
			let me = this;
			console.log(response.data.data);
			//me.items = response.data.data;
			me.$emit("afterLoadData");
		},
		loadDataError(error) {
			let me = this;
			console.log(error);
			me.$emit("afterLoadData");
		},
	},
};
</script>

<style></style>
